// v2: 사다리 자연스러움 정렬 — 오답 타일 구성이 바뀐다
// v3: 판 시드 파생 · 진전 카운터 리셋 · idealTicks 누적 차분 · 정지 틱 방향 미소비 ·
//     한 틱 이중 closeWord 방지 · WORD_CLEAR 진입 시 잔여 타일 제거
// v4: 봉인 구조(SEAL.md) — 길이 경제 뒤집기(정답 −1 · 완성 −2/−3 · 오답 +1 · 자동 성장) ·
//     pending 지연 실현 · 정확한 vacating · 길이 상한 40 = engorged 종료 · 점수/타임아웃/하한 예외 폐지 ·
//     명목 시간 = tick × 135ms · 순위 (sealed, solved, lastSolveTick)
// v5: 사다리 블록리스트 검수(DATA.md §5.3) — 사문화 음절 66자 + 비속어 2자 추가. 창이 밀려 오답 타일 구성이 바뀐다
export const ENGINE_VERSION = 6;
